var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#444",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 23.5,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCircle);
export default __webpack_public_path__ + "static/media/marker_circle.2c063447fc5eaf462c803f64db6386e9.svg";
export { ForwardRef as ReactComponent };